var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarIconNoresults(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "https://www.w3.org/2000/svg",
    width: 72,
    height: 40
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "car-icon-noresults_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.133333 0 0 0 0 0.462745 0 0 0 0 0.890196 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#car-icon-noresults_svg__a)",
    transform: "translate(-851 -454)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M854.601 481.546c.41 0 .744-.333.744-.744v-6.69a5.947 5.947 0 015.947-5.948h1.419c.282 0 .54-.16.666-.41l4.833-9.694a5.926 5.926 0 015.335-3.27h23.82a5.926 5.926 0 015.338 3.271l4.833 9.692c.127.252.384.41.666.41h8.85a5.95 5.95 0 015.948 5.949v7.435a4.432 4.432 0 01-4.018 4.422.741.741 0 01-.803-.53 8.922 8.922 0 00-17.132.03.748.748 0 01-.714.539h-22.321a.746.746 0 01-.714-.539 8.898 8.898 0 00-17.397 1.371.741.741 0 01-.738.655h-4.562a2.975 2.975 0 010-5.948zm33.456-15.613c0 .41.333.744.744.744h10.337a.742.742 0 00.633-.353.741.741 0 00.033-.724l-2.233-4.46a.743.743 0 00-.664-.411h-8.106a.743.743 0 00-.744.743v4.461zm-16.927.393c.136.218.374.35.63.35h9.606c.41 0 .743-.332.743-.743v-4.475a.743.743 0 00-.743-.744h-7.375a.742.742 0 00-.666.41l-2.23 4.461a.747.747 0 00.035.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.565 487.91a5.948 5.948 0 11-11.896 0 5.948 5.948 0 0111.896 0zm-40.89 0a5.948 5.948 0 11-11.896 0 5.948 5.948 0 0111.896 0z"
  })))));
}
export default SvgCarIconNoresults;